export default function PageHero({ eyebrow, title, body, image, imageAlt = '' }) {
  return (
    <section className={`page-hero ${image ? 'has-image' : ''}`}>
      {image && <img src={image} alt={imageAlt} />}
      {image && <div className="page-hero-shade" />}
      <div className="page-width page-hero-inner">
        <p className={`eyebrow ${image ? 'eyebrow-light' : ''}`}>{eyebrow}</p>
        <h1>{title}</h1>
        {body && <p>{body}</p>}
      </div>
    </section>
  );
}
